export default "__VITE_ASSET__1b0dd391__"